<template>
  <!--经纬度上传组件 -->
  <el-dialog
    :title="title"
    style="color:white"
    :visible.sync="dialogFormVisible"
    append-to-body
    custom-class="mainDialog"
  >
    <el-radio-group v-model="wradio" class="radiobuttons" v-if="$route.path === '/subscriptionData'" @change="radioClick">
      <el-radio v-model="wradio" label="1">行政区划</el-radio>
      <el-radio v-model="wradio" label="2">经纬度</el-radio>
    </el-radio-group>
    <div class="samlltitle">经纬度</div>
    <div class="infobody">

      <div class="inputdiv">

        <div class="inputinfo">左 <el-input
            v-model="leftvalue"
            placeholder="73 - 136"
            max='136'
            min="73"
          ></el-input>
        </div>
        <div class="inputinfo">右<el-input
            v-model="rightvalue"
            placeholder="73 - 136"
          ></el-input>
        </div>
      </div>
      <div class="inputdiv">
        <div class="inputinfo">上<el-input
            v-model="topvalue"
            placeholder="4 - 54"
          ></el-input>
        </div>
        <div class="inputinfo">下<el-input
            v-model="downvalue"
            placeholder="4 - 54"
          ></el-input>
        </div>
      </div>

    </div>
    <div style="margin-top: 20px;text-align: center;" v-if="$route.path === '/subscriptionData'">
      <el-button class="buttongteys" @click="preStep">上一步</el-button>
      <el-button style="margin-left: 60px;" class="buttongtey" type="primary" @click="nextStep">下一步</el-button>
    </div>
    <div style="margin-top: 20px;text-align: center;" v-else>
      <el-button
        class="buttongtey"
        type="primary"
        @click="saveweft"
      >确 定</el-button>
      <el-button
        style="margin-left: 60px;"
        class="buttongteys"
        @click="dialogFormVisible = false"
      >取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import Map from '../../common/map/Tmap.js'
export default {
  name: 'HeadWeftDialog',
  props: ['msgFather', 'prodata', 'radio'],
  data () {
    return {
      dialogFormVisible: false,
      leftvalue: '',
      rightvalue: '',
      topvalue: '',
      wradio: '2',
      downvalue: ''
    }
  },
  created () {
  },
  computed: {
    title() {
      return this.$route.path === '/subscriptionData' ? '空间范围' : '选择范围'
    }
  },
  methods: {
    saveweft () {
      var left = this.leftvalue * 1
      var right = this.rightvalue * 1
      var top = this.topvalue * 1
      var bottom = this.downvalue * 1
      if (left <= 136 && left >= 73 && right <= 136 && right >= 73 && top <= 54 && top >= 4 && bottom <= 54 && bottom >= 4 && left < right && bottom < top) {
        Map.AddRectangle2Source(top, right, bottom, left, true)
        this.$emit('getQueryType', '2')
        localStorage.setItem('queryType', '2')
        this.$emit('getRange', 'custom')
      } else if (isNaN(left) || isNaN(right) || isNaN(top) || isNaN(bottom)) {
        this.$message({
          message: '请输入完整！',
          type: 'warning'
        })
        return
      } else if (left < 73 || left > 136) {
        this.$message({
          message: '左侧经度范围为 73 - 136',
          type: 'warning'
        })
        return
      } else if (right < 73 || right > 136) {
        this.$message({
          message: '右侧经度范围为 73 - 136',
          type: 'warning'
        })
        return
      } else if (top < 4 || top > 54) {
        this.$message({
          message: '上方纬度范围为 4 - 54',
          type: 'warning'
        })
        return
      } else if (bottom < 4 || bottom > 54) {
        this.$message({
          message: '下方纬度范围为 4 - 54',
          type: 'warning'
        })
        return
      } else if (left >= right) {
        this.$message({
          message: '右侧经度需要大于左侧经度',
          type: 'warning'
        })
        return
      } else if (bottom >= top) {
        this.$message({
          message: '下方纬度需要小于上方纬度',
          type: 'warning'
        })
        return
      }
      this.dialogFormVisible = false
      var drawstyle3 = '经纬度'
      document.getElementById('drawstyle3').innerHTML = drawstyle3
      document.getElementById('fooderxzqy').innerHTML = ''
      document.getElementById('drawstyle1').innerHTML = ''
      document.getElementById('drawstyle2').innerHTML = ''
      document.getElementById('drawstyle4').innerHTML = ''
      return true
    },
    radioClick (val) {
      if (val === '1') {
        this.$emit('showBoundaryDialog', val)
      }
    },
    nextStep() {
      if (this.saveweft()) {
        this.$emit('getSetdialogFormVisible', true)
      }
    },
    preStep() {
      this.dialogFormVisible = false
      this.$emit('getdaydialogFormVisible', true)
    },
    sendMsgToParent () {
      this.$emit('getweftdialogFormVisible', this.dialogFormVisible)
    }
  },
  watch: {
    msgFather (curVal) {
      this.dialogFormVisible = curVal
    },
    dialogFormVisible () {
      this.sendMsgToParent()
    },
    radio(val) {
      this.wradio = val
    }
  }
}
</script>
<style scoped>
.inputinfo {
  display: flex;
  line-height: 5;
  letter-spacing: 20px;
  margin-left: 40px;
}
.inputdiv {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}
.samlltitle {
  margin-top: 20px;
  text-align: left;
  color: #18bc9c;
  margin-left: 5%;
}
.radiobuttons {
  width: 90%;
  margin-left: 5%;
  margin-top: 20px;
  text-align: left;
  border-bottom: 1px #606266 solid;
}
.infobody {
  width: 90%;
  margin-left: 5%;
  margin-top: 5px;
}
.el-dialog__header {
  background: #1d202f;
  border-radius: 8px 8px 0 0;
  height: 1.25rem;
}
.dialog__header span {
  color: white;
}
.el-dialog {
  position: relative;
  margin: 0 auto 50px;
  border-radius: 8px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/components/HeadMenu/HeadWeftDialog.vue